import $api from "@/frontend/shared/api/axios";

export async function moveCompany({ stageId, id }: { stageId: number; id: number }) {
  return $api.patch(`/portfolio-companies/${id}/stage`, {
    stageId
  });
}
